import DashboardSideBarNavItemContainer from './DashboardSideBarNavItem.container';

export default DashboardSideBarNavItemContainer;
